// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"385":"5c3f6a6f","453":"d855a71b","814":"4aa519c9"}[chunkId] + ".chunk.js";
};